<div class="kpi">
  <div class="kpi_header">
    <div class="kpi_header_title">
      <span>{{ titre() }}</span>
    </div>
    @if (isKpiValid()) {
      <div class="kpi_header_pourcent_trend">
        <div class="kpi_header_pourcent" [ngClass]="estObjectifAtteint() ? 'objectif_atteint' : 'objectif_non_atteint'">
          <span>{{ kpi().pourcentage }}%</span>
        </div>
        @if (kpi().tendance) {
          <div class="kpi_header_trend">
            <ion-icon
              color="dark"
              name="{{ kpi().tendance === 'POSITIVE' ? 'trending-up' : 'trending-down' }}"
            ></ion-icon>
          </div>
        }
      </div>
    } @else {
      <div class="kpi_pas_de_donnees">{{ 'KPIS_TECHNICIEN.PAS_DE_DONNEES' | translate }}</div>
    }
  </div>
  <div class="kpi_objectif">
    <div>{{ 'KPIS_TECHNICIEN.OBJECTIF' | translate }} : {{ objectif() }} %</div>
    @if (isKpiValid()) {
      <div>({{ kpi().realise }}/{{ kpi().total }})</div>
    }
  </div>
  <div class="kpi_definition">
    <span>{{ description() }}</span>
  </div>
</div>
